export const sendInvitationInitialState = {
	invitations: undefined,
	loading: false,
	error: null,
	errorShow: false,
	getData: false,
};
